import { KeyTermUnit } from '@client/graphql/__generated__/types';
import { getDotColor, getKeyTermRangeLabel } from '../common.utils';

export type CommonKeyTermProps = {
  value?: number | null;
  recommendation?: number;
  unit?: KeyTermUnit;
  range?: [number, number];
};

export const useCommonKeyTermLogic = (props: CommonKeyTermProps) => {
  const { recommendation, unit, range } = props;

  const isSingleRangeValue = range && range[0] === range[1];

  const placeholder = Math.round(recommendation ?? 0);

  const getDotColorValue = (value?: number | null): string => {
    return getDotColor({
      unit,
      value,
      range,
    });
  };

  const getRangeLabel = () =>
    getKeyTermRangeLabel({
      range,
      unit,
      isSingleValue: isSingleRangeValue,
    });

  return {
    isSingleRangeValue: isSingleRangeValue === true,
    getPlaceholderValue: () => placeholder,
    getDotColorValue,
    getRangeLabel,
  };
};
